/**
 Author - Saahil Madaan
 Git - https://bitbucket.org/techSavvySaahil/
 **/

"use strict";

import {
  addFaq,
  fetchAppArticles,
  fetchAppFaqs,
  fetchArticleExternal,
  fetchArticleInternal,
  fetchArticles,
  fetchArticlesByCategory,
  fetchArticlesByOrdering,
  fetchArticlesByYear,
  fetchAvailableArticleYears,
  fetchBatchContent,
  fetchCategories,
  fetchFaqs,
  modifyFaq,
  publishArticle,
  updateArticle,
  updateFaq,
  fetchAuthors,
  fetchAuthorDetail,
  fetchMediaData,
  fetchMediaYearsDev,
} from "./grey-matter";
import {
  confirmSubscription,
  createProposalForNavi,
  getAllIndianCities,
  getAppLink,
  getEventSchedule,
  getOnboardingAnswers,
  getOnboardingQuestions,
  getPartnerName,
  getPartnerSignupApiKey,
  handleAuthentication,
  handleMpinSetup,
  handleOtpVerification,
  handleResendOtp,
  handleResetPin,
  handleValidatePin,
  partnerLoginSignupWithCaptcha,
  postCampaignData,
  postOnboardingQuestions,
  reSendExistingSignInOtp,
  reSendSignUpOtp,
  registerAdvisor,
  registerAdvisorWithCaptcha,
  registerClient,
  registerFor100CroreEvent,
  registerForEvent,
  registerForGetWealthyEvent,
  registerForGrowMfdBusiness,
  registerForWealthyTalkz,
  registerForWealthyWorkshop,
  registerPrivateWealthPartners,
  requestCapitalGainTax,
  requestNewsletterSubscription,
  requestSubscription,
  resendClientOtp,
  resetPasswordConfirm,
  resetPasswordRequest,
  sendOtp,
  skipOnboardingQuestionnaire,
  skipOnboardingQuestionnaireV1,
  storeAdvisorBasicInfo,
  storeAdvisorOptionalInfo,
  subscribeToNewsletter,
  updateOnboardingAnswers,
  validateClientOtp,
  validateExistingSignInOtp,
  validateReferralCode,
  validateSignUpOtp,
  validateWebSignInOtp,
  validateWebSignUpOtp
} from "./rest";

export {
  confirmSubscription,
  requestCapitalGainTax,
  requestSubscription,
  requestNewsletterSubscription,
  storeAdvisorBasicInfo,
  storeAdvisorOptionalInfo,
  fetchAppArticles,
  fetchArticles,
  fetchArticlesByCategory,
  fetchAvailableArticleYears,
  fetchArticlesByYear,
  fetchArticlesByOrdering,
  fetchArticleInternal,
  fetchArticleExternal,
  fetchFaqs,
  addFaq,
  modifyFaq,
  updateFaq,
  updateArticle,
  publishArticle,
  fetchBatchContent,
  fetchCategories,
  fetchAppFaqs,
  fetchAuthors,
  fetchAuthorDetail,
  fetchMediaData,
  fetchMediaYearsDev,
  registerAdvisor,
  partnerLoginSignupWithCaptcha,
  registerAdvisorWithCaptcha,
  validateSignUpOtp,
  validateWebSignUpOtp,
  validateWebSignInOtp,
  validateExistingSignInOtp,
  validateReferralCode,
  getPartnerSignupApiKey,
  sendOtp,
  reSendSignUpOtp,
  reSendExistingSignInOtp,
  updateOnboardingAnswers,
  getAppLink,
  registerForWealthyTalkz,
  registerPrivateWealthPartners,
  getOnboardingQuestions,
  getAllIndianCities,
  postOnboardingQuestions,
  skipOnboardingQuestionnaire,
  skipOnboardingQuestionnaireV1,
  getOnboardingAnswers,
  registerForEvent,
  registerForWealthyWorkshop,
  registerFor100CroreEvent,
  registerForGetWealthyEvent,
  registerClient,
  validateClientOtp,
  resendClientOtp,
  createProposalForNavi,
  registerForGrowMfdBusiness,
  getEventSchedule,
  handleAuthentication,
  handleOtpVerification,
  handleMpinSetup,
  handleValidatePin,
  handleResendOtp,
  handleResetPin,
  getPartnerName,
  postCampaignData,
  resetPasswordRequest,
  resetPasswordConfirm,
  subscribeToNewsletter
};
